import { gql } from '@apollo/client'

export const SEND_JAPANESE_EMAIl = gql`
  mutation SendJapaneseEmail($inputData: JapaneseEmailInput!) {
    sendJapaneseEmail(inputData: $inputData)
  }
`
